import { DataSecurityLevel, } from '@office-start/instrumentation-types';
import { getReferralFromElementId } from './getReferralFromElementId';
/**
 * getLaunchInstrumentationParamsFromKnownArea gets the LaunchInstrumentationParams from the known area parameter.
 * LaunchInstrumentationParams is used by the telemetry instrumentation-service.
 * This event will be a 'click' event with the name ${area}_click
 * @param area The KnownAreas for telemetry, such as 'AppBar', 'Edgeworth', 'Recommended', etc
 * @param action The string value for action. 'default' is the default value.
 * @param elementId The Id of the element that was clicked, such as "office_mycontent", "office_outlook", "office_teams", "office_word"
 * @param isNewTab The boolean flag to show if this is opening in new tab or current tab
 * @return The LaunchInstrumentationParams for telemetry to use.
 */
export function getLaunchInstrumentationParamsFromKnownArea(area, action, elementId, isNewTab) {
    var referralFromElementId = getReferralFromElementId(elementId);
    var clickParams = {};
    clickParams["Area" /* InstrumentationParam.Area */] = area;
    clickParams["Action" /* InstrumentationParam.Action */] = action !== null && action !== void 0 ? action : '';
    clickParams["Referral" /* InstrumentationParam.Referral */] = referralFromElementId !== null && referralFromElementId !== void 0 ? referralFromElementId : '';
    clickParams["TabState" /* InstrumentationParam.TabState */] = isNewTab ? 'New' : 'Current';
    var LaunchInstrumentationParams = {
        area: area,
        clickParams: clickParams,
        dataSecurityLevel: DataSecurityLevel.Security,
        eventName: area + '_Click',
        elementId: elementId !== null && elementId !== void 0 ? elementId : '',
        referral: referralFromElementId !== null && referralFromElementId !== void 0 ? referralFromElementId : '',
    };
    return LaunchInstrumentationParams;
}
//# sourceMappingURL=getLaunchInstrumentationParamsFromKnownArea.js.map